import React from 'react';
import classNames from 'classnames';
import dynamic from 'next/dynamic';

import Img from '../../components/Img';

import { Section, SectionContainer } from '../../components/Section';
import Text from '../../components/Text/Text';

import Layout from '../../components/Layout/Layout';

import Styles from './Styles.module.scss';
const MetricItem = dynamic(() => import('../../components/Metrics/Item'));
const Metrics = dynamic(() => import('../../components/Metrics/Metrics'));

const aboutTeam = `${process.env.NEXT_PUBLIC_SITE_URL}/images/hero/about_team.jpg`;

const PressSection = dynamic(() =>
  import('../../components/PageComponents/PressSection/PressSection')
);

const CallToAction = dynamic(() =>
  import('../../components/PageComponents/CallToAction/CallToAction')
);

const list = [
  '/images/customers/gray/unilever@2x.png',
  '/images/customers/gray/huawei@2x.png',
  '/images/customers/gray/expedia@2x.png',
  '/images/customers/gray/uob@2x.png',
  '/images/customers/gray/carousell@2x.png',
  '/images/customers/gray/directasia@2x.png',
  '/images/customers/gray/johnsoncontrols@2x.png',
  '/images/customers/gray/marriott@2x.png',

  '/images/customers/gray/dbs@2x.png',
  '/images/customers/gray/fujixerox@2x.png',
  '/images/customers/gray/mundipharma@2x.png',
  '/images/customers/gray/watsons@2x.png',
  '/images/customers/gray/we@2x.png',
  '/images/customers/gray/vizeum@2x.png',
];

export default function AboutPage(props) {
  const head = {
    title: `About | ${process.env.NEXT_PUBLIC_SITE_NAME}`,
    meta: [
      { name: 'og:image', content: aboutTeam },
      { name: 'twitter:image', content: aboutTeam },
    ],
  };

  return (
    <Layout pageHead={head}>
      <div>
        <div className={Styles.heroContainer}>
          <div className={Styles.heroFrame}>
            <div className={Styles.heroTextContainer}>
              <div className={Styles.heroText}>{`Connecting brands to the best in class`}</div>
              <div className={Styles.heroDescription}>
                {`${process.env.NEXT_PUBLIC_SITE_NAME} is a next-generation platform for brands to find top creative and digital talents to enhance their growth.`}
              </div>
            </div>
          </div>
        </div>
        <Section title={'Our Mission'} className={Section.Styles.ruler}>
          <div
            className={classNames(Section.Styles.children)}
            style={{ maxWidth: '600px', margin: 'auto' }}>
            <Text variation={Text.Variation.CENTER}>
              {`We founded ${process.env.NEXT_PUBLIC_SITE_NAME} to change how brands leverage talents and teams at scale. Our mission is to revolutionize the way teams work.`}
            </Text>
          </div>
        </Section>

        <SectionContainer className={classNames(Styles.splitContainer, Section.Styles.ruler)}>
          <div className={classNames(Styles.split)}>
            <div className={Styles.splitContent}>
              <Text size={Text.Size.SUBHEADLINE}>{`Our Talents`}</Text>
              <br />
              <Text>
                {`Companies that work with ${process.env.NEXT_PUBLIC_SITE_NAME} have access to some of the
                  best problem solvers in their field. Our talent network has
                  a track record of providing businesses with innovative
                  industry-first solutions to address their diverse needs.`}
              </Text>
            </div>
          </div>
          <div className={classNames(Styles.split, Styles.aboutImage)} />
        </SectionContainer>

        <div className=''>
          <Section title={'Our Customers'} className={Section.Styles.medium}>
            <div style={{ maxWidth: '600px', margin: 'auto' }}>
              <Text variation={Text.Variation.CENTER}>
                {`Brands both large and small leverage ${process.env.NEXT_PUBLIC_SITE_NAME}'s talent platform to flexibly and effectively scale their marketing efforts.`}
              </Text>
            </div>
            <br />
            <div className={Styles.customers}>
              {list.map((brand, i) => (
                <Img className={Styles.img} src={brand} alt={brand} height={100} key={i} />
              ))}
            </div>
          </Section>
          <Metrics type={SectionContainer.Type.PRIMARY_BLUE}>
            <MetricItem number={7} metric='%' caption={`Experts Accepted`} />
            <MetricItem number={48} metric='H' caption={`Average Time to Fill`} />
            <MetricItem number={10000} metric='+' caption={`Projects Completed`} />
            <MetricItem number={96} metric='%' caption={`First Match Success`} />
          </Metrics>
          <PressSection title={`Press Highlights`} light />

          <CallToAction />
        </div>
      </div>
    </Layout>
  );
}

AboutPage.propTypes = {};
